export const TimePeriodRecentPerformance = {
    Current: 'Current',
    Last7Days: 'Last7Days',
    Last30Days: 'Last30Days'
};

export const TimePeriodsRecentPerformance = [
    TimePeriodRecentPerformance.Current,
    TimePeriodRecentPerformance.Last7Days,
    TimePeriodRecentPerformance.Last30Days
];
